/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const postPasteAction = (exploreVM, result) => {
	let cardIdsPasted;
	if (
		result &&
		result.value &&
		result.value.parameter &&
		result.value.parameter.model &&
		result.value.parameter.model.layout
	) {
		const layouts = result.value.parameter.model.layout;
		cardIdsPasted = layouts
			.map(layout => layout.id);
	}

	if (result) {
		exploreVM.setBestDisplayedToCard(cardIdsPasted);
	}
	return cardIdsPasted || [];
};

export {
	postPasteAction
};



// WEBPACK FOOTER //
// ./src/js/util/CopyPasteUtils.js